import React from 'react'
import { SearchForm } from '../../search/SearchForm/SearchForm'
import { StyledSearchIcon } from '../../search/SearchForm/SearchForm.styled'
import { StyledSearchLink } from './SearchAction.styled'

export const SearchAction: React.FC<{
    isLarge?: boolean
    onSubmit?: () => void
}> = ({ isLarge = false, onSubmit }) => {
    return (
        <React.Fragment>
            {!isLarge && (
                <StyledSearchLink isLarge={isLarge} to="/search">
                    <StyledSearchIcon />
                </StyledSearchLink>
            )}
            <SearchForm
                isLarge={isLarge}
                inMainNavigation={true}
                hasPlaceholder={true}
                onSubmit={onSubmit}
            />
        </React.Fragment>
    )
}
SearchAction.displayName = 'SearchAction'
